/**
 * SendProposal — Redirect to ProposalBuilder (merged in V2).
 *
 * Kept for backward compat — any bookmarked /send URLs will land on ProposalBuilder.
 */
import { Navigate, useParams } from 'react-router-dom';

export default function SendProposal() {
  const { orgSlug, dealId } = useParams();
  return <Navigate to={`/org/${orgSlug}/deal/${dealId}/proposal`} replace />;
}
